import IconDoneAll from '@icons/IconDoneAll';
import Card from '@ui/Card';
import {
  Button,
  ButtonSizes,
  ButtonVariants,
  Spinner,
  Modes
} from 'stubben-edge-unified-frontend-react-components';
import NotificationItem from '@layouts/components/Header/components/NotificationPanel/NotificationItem';
import { useNotificationContext } from '@layouts/components/Header/components/NotificationPanel/context';
import InfiniteScroll from '../../../../../common/InfiniteScroll';

const NotificationList = () => {
  const {
    hasMore,
    count,
    inbox,
    fetchData,
    currentPage,
    fetching,
    workingAll,
    markAllAsRead
  } = useNotificationContext();

  const loadMore = () => {
    if (hasMore) fetchData(currentPage + 1);
  };

  const handleMarkAllAsRead = () => {
    markAllAsRead();
  };

  return (
    <Card className="relative w-full overflow-hidden">
      <div className="flex flex-nowrap items-center justify-between space-x-2 px-5 py-3">
        <span className="text-lg font-medium">Notifications</span>
        {count > 0 && (
          <Button
            size={ButtonSizes.SM}
            variant={ButtonVariants.Tertiary}
            mode={Modes.Ghost}
            className="uppercase"
            leftSlot={<IconDoneAll />}
            loading={workingAll}
            onClick={handleMarkAllAsRead}
          >
            Mark all as read
          </Button>
        )}
      </div>
      {inbox.length === 0 ? (
        <div className="flex items-center justify-center pb-10 pt-6">
          <span className="text-gray-500">
            {fetching ? 'Loading...' : 'No Notifications'}
          </span>
        </div>
      ) : (
        <div className="visible-scrollbar max-h-[26rem] overflow-auto pb-2">
          <InfiniteScroll onLoadMore={loadMore} hasMore={hasMore}>
            {inbox.map((item) => (
              <NotificationItem notification={item} key={item.id} />
            ))}
          </InfiniteScroll>
        </div>
      )}
      {fetching && (
        <div className="absolute bottom-0 left-0 right-0 flex items-center justify-center bg-gradient-to-t from-white via-white/50 p-4 text-primary">
          <Spinner width={20} height={20} />
        </div>
      )}
    </Card>
  );
};

export default NotificationList;
